import { enumToNameWithDefault, rawValueToEnumWithDefault } from '@ps-smart-cp/ppfw-client';
import { imporJudgeIfrsBasisConfig } from './ImporJudgeIfrsBasis.name';

/** 重要性判定(IFRS基準)のENUM */
enum ImporJudgeIfrsBasis {
  /** 実施しない */
  notExecute = '0',
  /** 実施する */
  execute = '1',
}

const imporJudgeIfrsBasisMap = new Map([
  ['0', ImporJudgeIfrsBasis.notExecute],
  ['1', ImporJudgeIfrsBasis.execute],
]);

const rawValueToImporJudgeIfrsBasis = rawValueToEnumWithDefault(
  imporJudgeIfrsBasisMap,
  ImporJudgeIfrsBasis.notExecute,
);

const imporJudgeIfrsBasisToDisplay = enumToNameWithDefault(ImporJudgeIfrsBasis, imporJudgeIfrsBasisConfig);

const imporJudgeIfrsBasisToDisplayWithPrefix = enumToNameWithDefault(
  ImporJudgeIfrsBasis,
  imporJudgeIfrsBasisConfig,
  true,
);

export {
  ImporJudgeIfrsBasis,
  imporJudgeIfrsBasisToDisplay,
  imporJudgeIfrsBasisToDisplayWithPrefix,
  rawValueToImporJudgeIfrsBasis,
};
